<template>
  <div>
    <b-table
      v-bind="$attrs"
      v-on="$listeners"
      ref="dataTable"
      :fields="fields"
      :items="myProvider"
      :current-page.sync="currentPage"
      :per-page="perPage || 10"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :busy.sync="loading"
      :api-url="ep"
      @sort-changed="
        $router.replace({
          ...$router.currentRoute,
          query: {
            ...$route.query,
            sortDesc: $event.sortDesc,
            sortBy: $event.sortBy,
          },
        })
      "
      @update:busy="disabled = $event"
      empty-filtered-text="لا يوجد نتائج تطابق البحث"
      empty-text="لا يوجد سجلات لعرضها"
      no-local-sorting
      show-empty
    >
      <template #table-busy>
        <div class="text-center text-info my-2">
          <b-spinner class="align-middle mx-2"></b-spinner>
          <strong>جاري التحميل...</strong>
        </div>
      </template>
      <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
        <slot :name="name" v-bind="data"></slot>
      </template>
    </b-table>
    <div class="my-1">
      <b-row>
        <b-col
          lg="5"
          sm="12"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          عدد المدخلات في الصفحة
          <b-form-select
            :disabled="disabled"
            style="width: 50%"
            :value="perPage || 10"
            :options="pageOptions"
            class="mx-1"
            @input="
              $router.replace({
                ...$router.currentRoute,
                query: { ...$route.query, size: $event },
              })
            "
          />

          <!-- <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span> -->
        </b-col>
        <!-- Pagination -->
        <b-col
          lg="7"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination-nav
            :disabled="disabled"
            use-router
            :link-gen="linkGen"
            :number-of-pages="pagesNum"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
          >
            <template #prev-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
          </b-pagination-nav>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BTable,
  BPaginationNav,
  BFormSelect,
  BRow,
  BCol,
  BSpinner,
} from "bootstrap-vue";
// import { mapGetters, mapActions } from "vuex";
// import tableStore from "./store";
import { rangeDateFormat } from "@/utils/utils";

export default {
  components: {
    BTable,
    BPaginationNav,
    BFormSelect,
    BRow,
    BCol,
    BSpinner,
    BFormSelect,
  },
  props: {
    id: { type: String, default: () => Math.random().toString() },
    ep: { type: String, default: () => null },
    fields: { type: Array, default: () => [] },
    search: Object,
    currentPage: Number,
    perPage: Number,
    sortBy: String,
    sortDesc: Boolean,
  },
  data() {
    return {
      pageOptions: [10, 15, 20, 25],
      loading: false,
      disabled: false,
      totalRows: null,
      records: [],
      pagesNum: 10,
    };
  },
  computed: {
    // ...mapGetters("DataTable", ["pagination", "loading", "tableData"]),
    moduleName() {
      return `Data Table ${this.id}`;
    },
    getLoading() {
      return this.loading;
    },
  },
  methods: {
    linkGen(pageNum) {
      return this.$route.fullPath.indexOf("&") !== -1
        ? `?page=${pageNum}` +
            this.$route.fullPath.slice(this.$route.fullPath.indexOf("&"))
        : `?page=${pageNum}`;
    },
    refreshTable() {
      this.$refs.dataTable.refresh();
    },
    myProvider(ctx, callback) {
      this.loading = true;
      if (this.items) {
        callback(this.items);
      } else {
        var mappedForm = { ...this.search };
        const re = new RegExp(
          "^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2} إلى [0-9]{4}-[0-9]{1,2}-[0-9]{1,2}$"
        );
        for (const key in mappedForm) {
          if (Object.hasOwnProperty.call(mappedForm, key)) {
            const element = mappedForm[key];
            if (re.test(element)) {
              mappedForm[key] = {
                start: rangeDateFormat(element)[0],
                end: rangeDateFormat(element)[1],
              };
            }
          }
        }
        this.$axios
          .get(this.ep, {
            params: {
              page: ctx.currentPage,
              size: ctx.perPage,
              sortBy: ctx.sortBy.length > 0 ? ctx.sortBy : undefined,
              sortDesc: ctx.sortDesc ? "1" : "0",
              search: Object.keys(mappedForm).length > 0 ? mappedForm : null,
            },
          })
          .then((res) => {
            if (res.data.pagination) {
              this.pagesNum = res.data.pagination.last_page;
            }
            this.records = res.data.data;
            callback(res.data.data);
          })
          .catch((err) => {
            callback([]);
          });
      }

      this.loading = false;

      return null;
    },
  },
};
</script>
